import { defineMessages } from 'react-intl';

export const stepMessages = defineMessages({
	creationInProgressHeader: {
		id: 'step.madlib.creationInProgressHeader',
		defaultMessage: 'Setting up your space...',
	},
	creationInProgressSubheader: {
		id: 'step.madlib.creationInProgressSubheader',
		defaultMessage: 'Hold tight while we get everything ready.',
	},
	creationCompleteHeader: {
		id: 'step.madlib.creationCompleteHeader',
		defaultMessage: 'Your space is ready!',
	},
});
